import { render, staticRenderFns } from "./SpeedrunMilestoneCompare.vue?vue&type=template&id=ade67c12&scoped=true&"
import script from "./SpeedrunMilestoneCompare.vue?vue&type=script&lang=js&"
export * from "./SpeedrunMilestoneCompare.vue?vue&type=script&lang=js&"
import style0 from "./SpeedrunMilestoneCompare.vue?vue&type=style&index=0&id=ade67c12&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ade67c12",
  null
  
)

export default component.exports